export const getEmployeeTimeZoneDate = () => {
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  })
    .format(new Date())
    .replace(/\//g, "-");
};
